import { Injectable } from '@angular/core';
import { LocalStorageManager } from '@examdojo/browser/local-storage';
import { DerivativeQuestionReviewType, ReferenceQuestionReviewType } from '@examdojo/review';

@Injectable({
  providedIn: 'root',
})
export class ActiveModeService {
  readonly storage = new LocalStorageManager<{
    derivativeQuestionMode?: DerivativeQuestionReviewType;
    referenceQuestionMode?: ReferenceQuestionReviewType;
  }>('active-mode');

  getLastDerivativeQuestionMode(): DerivativeQuestionReviewType | null {
    return this.storage.getValue()?.derivativeQuestionMode ?? null;
  }

  getLastReferenceQuestionMode(): ReferenceQuestionReviewType | null {
    return this.storage.getValue()?.referenceQuestionMode ?? null;
  }

  setDerivativeQuestionMode(mode: DerivativeQuestionReviewType) {
    // clears also the reference question mode
    this.storage.setValue({ derivativeQuestionMode: mode });
  }

  setReferenceQuestionMode(mode: ReferenceQuestionReviewType) {
    // clears also the derivative question mode
    this.storage.setValue({ referenceQuestionMode: mode });
  }
}
